import { render, staticRenderFns } from "./PageLearningUnitReview.vue?vue&type=template&id=a02d0da2&"
import script from "./PageLearningUnitReview.vue?vue&type=script&lang=js&"
export * from "./PageLearningUnitReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports